import {
  DescriptionOutlinedIcon,
  NoRowsOverlay,
  type NoRowsOverlayProps,
} from '@shared/components';

export default function EmptyQuestionList(props: NoRowsOverlayProps) {
  return (
    <NoRowsOverlay
      icon={DescriptionOutlinedIcon}
      slotProps={{
        icon: { fontSize: 48 },
        wrapper: {
          sx: (theme) => ({
            '.MuiTypography-root': { fontSize: theme.typography.h5.fontSize },
            p: theme.spacing(4),
          }),
          disablePadding: true,
        },
      }}
      {...props}
    />
  );
}
